import { Box, Typography, styled } from "@mui/material"
import { InfoRounded } from "@mui/icons-material"

export const CardContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "space-between",
    backgroundColor: theme.palette.grey[300],
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    height: "161px",
    cursor: "pointer",
    maxWidth: "360px",
    boxSizing: "border-box",
}))

export const HeaderContainer = styled(Box)(() => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
}))

export const InfoIcon = styled(InfoRounded)(({ theme }) => ({
    width: 16,
    height: 16,
    color: theme.palette.grey[600],
    cursor: "pointer",
}))

export const IconWrapper = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 100,
    backgroundColor: theme.palette.grey[200],
}))

export const TitleTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.primary,
    fontWeight: 600,
}))

export const SubtitleTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
}))
